import InfoCard from '../InfoCard';
import { adaptGuide } from '../../data/DISC/adaptGuide.js';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { stressFactors } from '../../data/DISC/stressFactors.js';
import compliant from '../../assets/compliant.png'
import dominant from '../../assets/dominant.png'
import influential from '../../assets/influential.png'
import steady from '../../assets/steady.png'

function AdaptGuide() {
  let infoNum = [0, 1, 2, 3]
  const bgImages = [dominant, influential, compliant, steady];
  //const colorsAdapt = ['#f5cec1', '#e9ebb7', '#a6d2ed', '#0dd456']
  const cards = infoNum.map((rel) => (
    <InfoCard head={<b>{adaptGuide[rel].head}</b>}
      body={adaptGuide[rel].body}
      list={adaptGuide[rel].emphasize}
      adapt={true}
      bodyStress={stressFactors[rel].desc}
      action={stressFactors[rel].action}
      help={stressFactors[rel].help}
      style={{ 
        width: '25rem', 
        //backgroundColor: colorsAdapt[rel] 
        backgroundImage: `url(${bgImages[rel]})`,
        fontWeight: 'bold',
      }}
    />
  ))
  return (
    <Container className='bg-dark rounded-4 py-5'>

      <figure className="text-center" style={{ color: 'white' }}>
        <blockquote className="blockquote">
          <h2>How to Adapt - Quick Reference Guide</h2>
        </blockquote>
        <figcaption className="blockquote-footer">
          Adjusting to another person's personality style involves relating in a way that he or she is most receptive
        </figcaption>
      </figure>

      <Row className="justify-content-center py-1" lg={3}>
        <Col className='d-flex justify-content-center py-1'>{cards[0]}</Col>
        <Col className='d-flex justify-content-center py-1'>{cards[1]}</Col>
      </Row>

      <Row className="justify-content-center py-1" lg={3}>
        <Col className='d-flex justify-content-center py-1'>{cards[2]}</Col>
        <Col className='d-flex justify-content-center py-1'>{cards[3]}</Col>
      </Row>

    </Container>
  );
}

export default AdaptGuide;